export * from "./CognitoProviderParameters";
export * from "./fromCognitoIdentity";
export * from "./fromCognitoIdentityPool";
export * from "./Logins";
export * from "./Storage";
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyw2QkFBNkIsQ0FBQztBQUM1QyxjQUFjLHVCQUF1QixDQUFDO0FBQ3RDLGNBQWMsMkJBQTJCLENBQUM7QUFDMUMsY0FBYyxVQUFVLENBQUM7QUFDekIsY0FBYyxXQUFXLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgKiBmcm9tIFwiLi9Db2duaXRvUHJvdmlkZXJQYXJhbWV0ZXJzXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9mcm9tQ29nbml0b0lkZW50aXR5XCI7XG5leHBvcnQgKiBmcm9tIFwiLi9mcm9tQ29nbml0b0lkZW50aXR5UG9vbFwiO1xuZXhwb3J0ICogZnJvbSBcIi4vTG9naW5zXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9TdG9yYWdlXCI7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/@aws-sdk/credential-provider-cognito-identity/dist/es/index.js
// module id = 1715
// module chunks = 0